import { render, staticRenderFns } from "./LessonsList.vue?vue&type=template&id=de6828b8&scoped=true"
import script from "./LessonsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./LessonsList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LessonsList.vue?vue&type=style&index=0&id=de6828b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6828b8",
  null
  
)

export default component.exports